import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Image from 'next/image';
import { useDispatch } from 'react-redux';
import { InputAdornment, TextField } from '@material-ui/core';
import { NumericFormat } from 'react-number-format';

import { closeModal } from 'features/utilsSlice';
import { formatLargeNumber } from 'utils/helpers';
import { putRequest } from 'utils/api';
import { setGig } from 'features/gigsSlice';
import TransitionDialog from 'components/TransitionDialog';
import BottomButtons from 'components/BottomButtons';
import useModalOpen from 'hooks/useModalOpen';
import EyeIcon from 'public/icons/eye-purple.svg';
import styles from 'styles/components/milestones/UploadViewsDialog.module.scss';

const marginTop = { marginTop: 50 };

const ViewsDialog = ({ handleAttachViews, milestone, gig }) => {
  const [viewsCount, setViewsCount] = useState(0);
  const open = useModalOpen('Views');
  const dispatch = useDispatch();
  const views = formatLargeNumber(milestone.views);

  const viewsScreenshot = milestone.views_screenshot.url;

  const handleClose = () => dispatch(closeModal('Views'));

  const submitViews = () => {
    putRequest({
      endpoint: `milestones/${milestone.id}/update_views_count`,
      data: { views: formattedToNumber(viewsCount) },
    })
      .then(() => {
        const milestones = gig.milestones.map(m =>
          m.id === milestone.id ? { ...m, views: formattedToNumber(viewsCount) } : m
        );

        dispatch(setGig({ ...gig, milestones }));
        setViewsCount(0);
        dispatch(closeModal('Full Screenshot'));
        handleClose();
      })
      .catch(() => {});
  };

  const formattedToNumber = value => +`${value}`.replace(/,/g, '');

  return (
    <TransitionDialog open={open} handleClose={handleClose} noCloseIcon>
      <div className={styles.viewsContainer}>
        <div className={styles.imageContainer}>
          <Image layout="fill" src={viewsScreenshot} alt="Views Screenshot" unoptimized />
        </div>

        <div className={styles.content} style={marginTop}>
          {milestone.views > 0 ? (
            <div className={styles.views}>
              <EyeIcon width={35} height={35} style={{ position: 'absolute', left: 10 }} />

              <h2>{views} views</h2>
            </div>
          ) : (
            <NumericFormat
              customInput={TextField}
              thousandSeparator=","
              value={viewsCount}
              onChange={e => setViewsCount(e.target.value)}
              placeholder="Enter your views"
              variant="outlined"
              color="primary"
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <EyeIcon width={35} height={35} fill="#5b00db" />
                  </InputAdornment>
                ),
              }}
            />
          )}

          <span className={styles.text}>
            {milestone.views > 0 ? (
              'Is that correct?'
            ) : (
              <div style={{ textAlign: 'center' }}>
                <span>Unable to automatically extract views.</span>
                <br />
                <span>Please enter in your views above.</span>
              </div>
            )}
          </span>
        </div>

        <BottomButtons
          text="No, change"
          textContained={milestone.views > 0 ? 'Yes correct' : 'Done'}
          handleClose={handleAttachViews}
          handleClick={milestone.views > 0 ? handleClose : submitViews}
          disabled={formattedToNumber(viewsCount) <= 0 && milestone.views <= 0}
          fixed
        />
      </div>
    </TransitionDialog>
  );
};

ViewsDialog.propTypes = {
  handleAttachViews: PropTypes.func.isRequired,
  milestone: PropTypes.object.isRequired,
  gig: PropTypes.object.isRequired,
};

export default ViewsDialog;
